<div class="person" *ngIf="person$ | async as person">
    <div class="top" *ngIf="isParticipant">
        <h3>
            <span [innerHTML]="'booking.bookingSummary.participant' | translate"></span> <span> {{ orderNumber }}</span>
        </h3>
        <!-- <a class="delete"><span [innerHTML]="'bookingSummary.remove' | translate"></span></a> -->
    </div>
    <div class="group">
        <strong
            ><em *ngIf="person.salutation">{{ translatedSalutation }}</em> {{ person.title }} {{ person.firstName }}
            {{ person.lastName }}</strong
        >
        <span>{{ person.email }}</span>
        <span>{{ person.phone }}</span>
        <span *ngIf="person.department">{{ person.department }}</span>
    </div>
    <div class="group">
        <!-- <strong>{{ person.city }} </strong>
        <span>{{ person.address }}, {{ countryName }}</span> -->

        <span
            ><strong>{{ person.company }}</strong></span
        >
        <span class="user-info">
            <span>{{ person.address }}, {{ person.houseNumber }}</span> {{ person.zipCode }} {{ person.city }}, <ng-container *ngIf="person.regionKey && person.country === 'BR'">{{ person.regionKey }},</ng-container> {{translatedCountry }}
        </span>
    </div>
    <div class="group table" *ngIf="!isParticipant && !isBillingContact">
        <div>
            <strong [innerHTML]="'booking.bookingSummary.order' | translate"></strong>
            <span>{{ person.POnumber }}</span>
        </div>
        <div>
            <strong [innerHTML]="'booking.bookingSummary.note' | translate"></strong>
            <span>{{ person.note }}</span>
        </div>
    </div>
    <div class="button-wrapper">
        <a
            da-link
            class="button secondary"
            (click)="goToBookingParticipants()"
            *ngIf="isParticipant"
            [innerHTML]="'booking.bookingSummary.edit' | translate"
        ></a>
        <a
            da-link
            class="button secondary"
            (click)="goToBookingPerson()"
            *ngIf="!isParticipant"
            [innerHTML]="'booking.bookingSummary.edit' | translate"
        ></a>
    </div>
</div>
